<template>
  <a-card :bordered="false">
    <a-form layout="inline">
      <a-form-item>
        <a-input v-model="queryParams.productId" placeholder="请输入商品ID"></a-input>
      </a-form-item>
      <a-form-item>
        <a-input v-model="queryParams.productName" placeholder="请输入商品名称"></a-input>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
      </a-form-item>
    </a-form>
    <custom-page-table
      :queryParams="queryParams"
      style="margin-top: 16px;"
      ref="table"
      :columns="getColumns()"
      :requestPromise="loadPromise"
    >
      <template slot="proCatalogStr">抢购</template>
      <span slot="action" slot-scope="rowItem">
        <a-popconfirm
          title="此操作将手动同步该商品, 是否继续?"
          @confirm="handUpdate(rowItem.record.proChannelId, rowItem.record.proProductUrl)"
        >
          <a>手动同步</a>
        </a-popconfirm>
      </span>
    </custom-page-table>
  </a-card>
</template>

<script>
export default {
  name: 'ZwyList',
  data() {
    return {
      queryParams: {
        productId: '',
        productName: ''
      },
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      loadPromise: params => this.getListPromise(params)
    }
  },
  created() {
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'ZwyConnection', title: '同步商品' },
      { name: 'DirectOrder', title: '订单直连' },
      { name: 'AssociatedAccount', title: '关联账号' }
    ])
  },
  methods: {
    getColumns() {
      return [
        {
          title: '自我游ID',
          dataIndex: 'proProductUrl'
        },
        {
          title: '商品名称',
          dataIndex: 'proName',
          width: '40%'
        },
        {
          title: '类型',
          dataIndex: 'proCatalogStr',
          scopedSlots: { customRender: 'proCatalogStr' }
        },
        {
          title: '更新时间',
          dataIndex: 'proUpdateTime'
        },
        {
          title: '供应商名称',
          dataIndex: 'accountName'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      return this.getHttpServices().getProService().post('v2/zwy/rush/product/all', params)
    },
    //手动同步
    handUpdate(proChannelId, productUrl) {
      let params = {
        productId: productUrl,
        distributorId: proChannelId
      }
      this.getHttpServices()
        .getProService()
        .post('v2/zwy/rushId', params)
        .then(res => {
          this.$message.success('手动同步成功')
          // this.$refs.table.refresh(true)
        })
        .catch(err => {
          if (err && err.msg) {
            this.$message.error(err.msg)
          }
        })
    }
  }
}
</script>
<style scoped>
.dialog-footer {
  position: relative;
  left: 85%;
}
</style>
